import { render } from "./editproduct.vue?vue&type=template&id=1cd6d96c&scoped=true"
import script from "./editproduct.vue?vue&type=script&lang=js"
export * from "./editproduct.vue?vue&type=script&lang=js"

import "./editproduct.vue?vue&type=style&index=0&id=1cd6d96c&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd6d96c"]])

export default __exports__